<template>
  <page-section :content="content.sections.assessment1" />
  <page-section :content="content.sections.assessment2" />
</template>

<script setup>
import content from "../content.js";
import PageSection from "./../components/section/Section.vue";
</script>
